import { defineTool } from '@/shell/tool';

/** Customer Success Agent (Flutter `/agents/customer-success`). */
export default defineTool({
  id: 'customer-success-agent',
  title: 'Customer Success Agent',
  summary:
    "The agent that answers a customer's question about their lessons and their account.",
  section: 'agents',
  order: 10,
  icon: 'contact_support',
  owner: '@Drabu',
  permission: 'customer-success-agent:use',
  routes: () => import('./CustomerSuccessAgentPage'),
});
